if (window.jQuery) {

    (function ($) {

        var _current_edition = "";
        var _versions_container = "";

        var _versions = [];
        var _retailers = [];


        // Clicking on an edition tab
        $('#editions .edition-link').off('click').on('click', function (e) {

            e.preventDefault();

            $('#edition-content .version-selection').removeClass('d-none');

            _current_edition = $(this).data('edition');

            $('#editions .edition-link').removeClass('active');
            $(this).addClass('active');

            $('#edition-content').attr('data-edition', 'edition-' + _current_edition);

            if (_current_edition == 'standard') {

                // populate versions dropdown based on Retailers JSON
                _versions = _versions_list;
                _versions_container = $('#versions ul.dropdown-menu');
                _versions_container.empty();

                Object.entries(_versions).forEach(([key, value]) => {
                    _versions_container.append('<li><a class="dropdown-item" href="" data-version="' + value['slug'] + '">' + value['name'] + '</a></li>');
                });

                $('#edition-content #versions').attr('data-version', '');
                $('.dropdown-item', _versions_container).removeClass('active');
                $('#edition-content #versions #dropdownVersions').text(_select_version_text);

                // Resetting and Hiding Buy Button
                $('#edition-content #buy-btn').empty();

            } else {

                $('#edition-content .version-selection').addClass('d-none');

                _retailers = _final_retailers_list[_current_edition];

                $('#edition-content #buy-btn').empty();

                Object.entries(_retailers).forEach(([key, value]) => {
                    $('#edition-content #buy-btn').append('<a href="' + value['link'] + '" class="btn btn-secondary m-3" target="blank"><span>' + value['name'] + '</span></a>');
                });

            }



        });

        // Selecting a version in dropdown
        $('#edition-content').off('click', '#versions .dropdown-item').on('click', '#versions .dropdown-item', function (e) {

            e.preventDefault();

            _current_edition = $('#edition-content').data('edition').replace('edition-', '');

            var _version = $(this).data('version');
            $('#edition-content #versions').attr('data-version', _version);
            $('#edition-content #versions .dropdown-item').removeClass('active');
            $('#edition-content #versions .dropdown-item[data-version=' + _version + ']').addClass('active');
            $('#edition-content #versions #dropdownVersions').text($('#versions .dropdown-item[data-version=' + _version + ']').html());


            _retailers = _final_retailers_list[_current_edition][_version];

            $('#edition-content #buy-btn').empty();

            Object.entries(_retailers).forEach(([key, value]) => {
                $('#edition-content #buy-btn').append('<a href="' + value['link'] + '" class="btn btn-secondary m-3" target="blank"><span>' + value['name'] + '</span></a>');
            });


        });

    })(jQuery);

}